export const data = [
  {
    id: 1,
    type: "Data Science",
    title: "Data Starter",
    decription: `The Data Starter program helps newbies start their journey into Data Science 
      through a structured learning programme and coaching model.`,
    modules: [
      "Advanced Excel",
      "Data Strategy Introduction",
      "Structured Query Language",
      "Power BI",
      "Team Work",
      "Data Visual Presentation",
      "Capstone Projects",
    ],
    additionals: ["Data Strategy Introduction", "Data Visual Presentation"],
  },
  {
    id: 2,
    type: "Data Science",
    title: "Data Progression",
    decription: `The Data Progression helps those on your team who have started the 
    journey into Data Science accelerate and learn in a structured environment. `,
    modules: [
      "Advanced Excel",
      "Data Strategy Introduction",
      "Capstone Projects",
      "Structured Query Language",
      "Data Visual Presentation",
      "Team Work",
      "Power BI",
      "Data Leadership",
    ],
    additionals: [
      "Data Strategy Introduction",
      "Data Visual Presentation",
      "Data Leadership",
    ],
  },
  {
    id: 3,
    type: "Data Science",
    title: "Data Science Movers",
    decription: `This program is designed to help professionals 
    learn data science, data strategy & insight 
    reporting. Relevant skills to accelerate career growth.`,
    modules: [
      "SQL",
      "Power BI",
      "Python",
      "Data Strategy Intensive",
      "Data Visual Presentation",
      "Change Management",
    ],
    additionals: [
      "Data Strategy Intensive",
      "Data Visual Presentation",
      "Change Management",
    ],
  },
  {
    id: 4,
    type: "Data Science",
    title: "Data Science Intensive",
    decription: `This program will equip participants with the skills 
    to explore, clean and interpret data, and support decision making.`,
    modules: [
      "Advanced SQL",
      "Power BI, Tableau",
      "Python",
      "Data Strategy Intensive",
      "Data Visual Presentation",
    ],
    additionals: [
      "Data Strategy Intensive",
      "Data Visual Presentation",
      "Change Management",
    ],
  },
  {
    id: 5,
    type: "Data Science",
    title: "Data Leadership Bootcamp",
    decription: `This program is designed for professionals and top management 
    leaders to learn analytics and data 
    strategy & insight reporting. Relevant skills to be better managers.`,
    modules: [
      "Power BI",
      "Data Science Leadership",
      "AI Leadership Program",
      "Data Analytics ",
      "Fundamental",
      "Change Management",
      "Data Business Case",
      "Understanding Data Bias",
    ],
    additionals: [
      "Change Management",
      "Data Business Case",
      "Understanding Data Bias",
    ],
    tag: "top",
  },
  {
    id: 6,
    type: "Data Science",
    title: "Data Science Transformation Bootcamp",
    decription: `Gain practical data science skills and industry experience 
    through unique real-world projects where you'll collaborate with 
    designers, web developers, and digital marketers to solve real-world problems. 
    Learn why thousands of people have launched their new careers 
    through this Utiva Data Science Transformation Bootcamp.`,
    modules: [
      "Power BI",
      "Change Management",
      "Team Presentations",
      "Data Science Leadership",
      "Data Business Case",
      "Problem Exploratory Session",
      "AI Leadership Program",
      "Understanding Data Bias",
      "Data Analytics Fundamental",
    ],
    additionals: [
      "Data Strategy",
      "Understand Data Initiatives",
      "Data Modelling Experimentation",
    ],
  },
  {
    id: 7,
    type: "Product Marketing",
    title: "Product Marketing Starter",
    decription: `In this program you will learn how to successfully 
    introduce new products to your target audience. Product marketing 
    courses provide you with the knowledge and skills to research, 
    understand and effectively communicate with 
    potential customers. Level up your product launch, sales and profits. `,
    modules: [
      "Defining Concept",
      "Product Marketing Research",
      "Business Model 101",
      "Users and Personas",
      "Messaging",
    ],
    additionals: ["Digital Marketing", "Design Thinking", "SEO Optimization"],
    tag: "top",
  },
  {
    id: 8,
    type: "Product Marketing",
    title: "Product Marketing Intensives",
    decription: `This training is designed by top professionals to help 
    you fast-track your career in Product Marketing. Designed for 
    those that already have their foot in the industry. It is an intensive 
    program that digs deep into the concepts of Product Marketing. `,
    modules: ["Introduction To Product", "Marketing And Expanded Concepts"],
    additionals: ["Digital Marketing", "Design Thinking", "SEO Optimization"],
  },
  {
    id: 9,
    type: "Product Marketing",
    title: "Growth Leadership",
    decription: `This program is designed by top growth leaders to 
    help you understand and develop a growth 
    mindset/positive mindset in order to pivot your products to win.`,
    modules: [
      "Growth Mindset vs Fixed Mindset",
      "Eliminating Fixed Mindsets",
      "Awareness, perspective and action- Mindset for leaders",
      "Mindset Improvement",
      "Optimism",
      "Positive Thinking",
      "Growth through Goals (GTG)",
    ],
    additionals: [
      "Analytics and Presentation",
      "Communicating Strategy",
      "Change Management",
      "Thinking Like the CEO",
      "Working with the Product Team",
    ],
  },
  {
    id: 10,
    type: "Product Marketing",
    title: "Enterprise Immersion Program",
    decription: `The Enterprise Immersion Programme  has been designed 
    to provide aspiring businesses the opportunity to study a course on 
    entrepreneurship while undergoing an internship in a startup providing 
    practical and experiential 
    learning on how to become an entrepreneur.`,
    modules: [
      "Understand Your Business",
      "Unravelling the Business Model",
      "Understanding the Product",
      "Understand Our Users",
      "Messaging Our Product",
      "Positioning Our Product",
      "Go-To-Market Strategy",
      "Communication Strategy",
      "Sales Enablement",
      "Analysis & Optimization",
      "Unravelling the Dynamics of your Industry",
    ],
    additionals: ["Unraveling the Dynamics of your Industry"],
  },

  {
    id: 11,
    type: "Project Management",
    title: "Enterprise Project Management",
    decription: `This program is designed for Project Management Professionals 
    to learn the technicalities and intricacies of effectively managing 
    complex and wide-scale 
    projects simultaneously (both related and unrelated).`,
    modules: [
      "Risk Analysis",
      "Structured Estimating",
      "Project Reviews",
      "Project Management Coaching",
      "Escalated Issue Management",
      "Time Accounting",
      "Information System Management",
      "Monday.com",
      "LiquidPlanner",
      "Genius Project",
    ],
    additionals: ["Leadership Sessions", "Business Case Analysis"],
  },

  {
    id: 12,
    type: "Project Management",
    title: "Agile Project Management",
    decription: `This program is designed for professionals and top 
    management leaders to learn the processes and approaches of software 
    development projects which focuses on the 
    continuity, iterations and implementation of feedback effectively.`,
    modules: [
      "The fundamentals of Agile",
      "Scrum 101",
      "Implementing Scrum",
      "Applying Agile in the organisation",
      "Agile Manifesto",
      "Extreme Programming",
      "Scrum",
      "Kanban & Jira",
      "Design Thinking",
      "Project Leadership Strategy",
    ],
    additionals: ["Project Leadership Strategy", "Design Thinking"],
    tag: "top",
  },

  {
    id: 13,
    type: "Project Management",
    title: "Project Management Fast-Track",
    decription: `This program is designed to help professionals to fast track the learning of building a team project from the initiation to the closing of the project.
    They would also learn to manage and complete the project with the listed goals. This would involve smart budgeting, defining goals, resource management and swift communication to the teams and stakeholders.
    `,
    modules: [
      "Initiating a Project",
      "Business Case for Project",
      "Planning a Project Schedule",
      "Planning Project Costs",
      "Planning Project Quality, Resources, And Procurements",
      "Planning Stakeholder Engagement And Communications",
      "Executing a Project",
      "Working With Stakeholders",
      "Monitoring a Project",
      "Controlling a Project",
      "Closing a Project",
    ],
    additionals: ["Team Leadership", "Team Strength Assessment"],
  },

  {
    id: 14,
    type: "Project Management",
    title: "PMO Bootcamp",
    decription: `This program is designed by a team of Project Management 
    specialists to help you understand how to set up a Project Management Office (PMO). You would acquire skills that will help you learn how to deliver all organisational 
    projects with high quality and achieve their defined outcomes. `,
    modules: [
      "Introduction (definition and principles) to Project Management Office (PMO)",
      "Identify the type of PMO you have to build",
      "Different roles and responsibilities of a Project Management Office (PMO)",
      "Select the right projects that will deliver the biggest value.",
      "PMO-specific tools, templates, frameworks & other resources.",
      "Developing the attributes required to be an outstanding PMO leader.",
      "Change management for your PMO roll-out.",
      "Leading Through Barriers for PMO Development.",
      "Scaling PMO with CFO",
    ],
    additionals: ["Team Leadership", "Team Strength Assessment"],
  },
  {
    id: 15,
    type: "Project Management",
    title: "Bootcamp for Project Managers",
    decription: `This intensive program will examine the basics of 
    putting together a well-defined, planned, and executed project. 
    Participants will learn how to define, plan and execute a project 
    whether the goal is simple or complex; gain the tools and knowledge 
    for delivering projects on time and on budget, while meeting performance 
    specifications; explore the basic 
    components of project management and the project life cycle.`,
    modules: [
      "Introduction to PM",
      "PM Frameworks",
      "Project Management Lifecycle",
      "Project Management Integration",
      "Project Scope Management",
      "Project Time Management",
      "Project HR Management",
      "Project Quality Management",
      "Project Risk Management",
      "Project Communication Management",
      "Project Stakeholders Management",
      "Project Closing",
      "Post-Project Lifecycle",
    ],
    additionals: ["Team Leadership", "Team Strength Assessment"],
  },

  {
    id: 16,
    type: "Product Management",
    title: "Design Thinking Appreciation",
    decription: `This program is designed by top professionals to make 
    you a design thinking expert. At the end of this program, 
    you would have built capacity on every aspect of design thinking.`,
    modules: [
      "Design Thinking Training",
      "Design Thinking Framework",
      "Design Thinking Tools",
    ],
    additionals: ["Product Leadership", "Product Challenges"],
    tag: "top",
  },
  {
    id: 17,
    type: "Product Management",
    title: "Design Bootcamp",
    decription: `This program is designed by thought leaders to introduce 
    you to the world of User Interface and User Experience (UI/UX) design 
    and equip you with skills 
    needed to create user experiences for products or digital properties.`,
    modules: [
      "User Research",
      "Information Architecture",
      "Sketching and Wireframing (low fidelity and high fidelity mockups) with the use of Figma.",
      "Design tools: Sketch, etc",
    ],
    additionals: ["Product Leadership", "Research and Experimentation"],
  },
  {
    id: 18,
    type: "Product Management",
    title: "Product Strategy Bootcamp",
    decription: `This program is designed to help professionals learn 
    the framework of thinking about products in a new way, clarifying 
    what role(s) product strategy plays as part of the broader process of 
    developing new offerings and decision making process that sets product or 
    service on the right track for success. 
    `,
    modules: [
      "Product Marketing",
      "Growth Marketing",
      "Product Strategy",
      "Product Metrics",
      "Product Leadership",
      "Team Leadership",
    ],
    additionals: ["Leadership Training", "Testing Pressure", "Failing Forward"],
  },
  {
    id: 19,
    type: "Product Management",
    title: "Product for Newbies",
    decription: `This training is designed by top professionals to 
    help you fast-track your career in Product Management. Designed 
    for those that already have their foot in the industry and want 
    to fast-track their career through in-depth knowledge and also want to 
    build a leading industry relationship that converts to jobs.
    `,
    modules: [
      "Design Thinking",
      "Product Design",
      "Product Strategy Elementary",
      "Product Launch",
      "Building And Refining Products",
      "Leadership That Scales",
    ],
    additionals: ["Building And Refining Products", "Leadership That Scales"],
  },
  {
    id: 20,
    type: "Product Management",
    title: "Product For Leaders",
    decription: `Product management at leadership level is strategic 
    and this program is designed to equip leaders 
    with essential knowledge & skills needed to drive product teams.
    `,
    modules: [
      "Strategy and Scale",
      "Unbundling Growth",
      "Aligning New Models",
      "New Technologies",
      "Metrics and Stories",
      "Hiring the Best",
    ],
    additionals: ["Building And Refining Products", "Leadership That Scales"],
  },
  {
    id: 21,
    type: "Product Management",
    title: "Product Intensives",
    decription: `This program is designed to help professionals learn 
    the framework of thinking about products in a new way, clarifying  
    what role(s) product strategy plays as part of the broader process of 
    developing new offerings and decision making 
    process that sets product or service on the right track for success. 
    `,
    modules: [
      "Product Management Fundamentals",
      "Design Thinking",
      "Product Design",
      "Building And Refining Products",
      "Agile Methodology & Scrum Framework",
      "Product Strategy",
      "Metrics For Product Managers",
      "Product Launch",
    ],
    additionals: ["Product Leadership", "Personality Testing"],
  },
  {
    id: 22,
    type: "Software Engineering",
    title: "Full Stack Engineering Bootcamp",
    decription: `This program helps you build the technical skills necessary 
    to work in software or web development. These 
    short-term programs focus on in-demand skills sought by employers. 
    `,
    modules: [
      "Core of Engineering",
      "Front End Stacks",
      "Backend Stacks",
      "Product Design",
      "Agile Product Management",
      "Understanding Teamwork",
    ],
    additionals: ["Agile Product Management", "Understanding Teamwork"],
  },
  {
    id: 23,
    type: "Software Engineering",
    title: "Developers Accelerator",
    decription: `This Program is tailored specifically for enterprises, 
    local markets using advanced technologies in helping enterprises build 
    great products. Using the knowledge gained from running startup accelerators, 
    this model has been used to reach other audiences such as game 
    developers , profit oriented organisation, non-profits , etc
    `,
    modules: [
      "Coding Classes",
      "New Stacks Training",
      "Modernising Delivery",
      "Product Design",
      "Code Along Challenge",
    ],
    additionals: ["Agile Product Management", "Understanding Teamwork"],
  },
  {
    id: 24,
    type: "Software Engineering",
    title: "Accelerating Engineering Managers",
    decription: `The Program is designed to provide a unique learning 
    opportunity to engineers and help them upskill and thrive in their 
    engineering career.The program serves working professionals to 
    better carry out their functions within the organisation
    `,
    modules: [
      "Engineering Management Intro Session",
      "Engineering Management Networking Session",
      "Demystifying Engineering Management",
      "Transitioning from Individual Contributor to an Engineering Manager Role",
      "What Leadership Expect from Engineering Managers",
      "An Introduction to People Management",
      "Creating Your EM Story Bank",
      "An Introduction to Project Retrospectives",
      "Brainstorming Project Retro Ideas",
      "Introduction to System Design",
      "The System Design Interview",
    ],
    additionals: ["Engineering Management"],
  },
  {
    id: 25,
    type: "Software Engineering",
    title: "Digital MBA For Engineers",
    decription: `This program is ideal for those with professional 
    experience and a knowledge in a technical field who wish to 
    add business management theory and skills to their resume. It 
    is also valuable to those early in their career as technical 
    experts who wish to integrate 
    traditional business analysis into their daily practice.
    `,
    modules: [
      "Leadership & Team Building",
      "Business Fundamentals",
      "Technology Strategy & The Business Goals",
      "Personal Development",
      "Product Development",
      "Information Management",
      "Data Science & Analytics",
      "Finance & Funding",
      "Digital Trends and Innovation",
      "Strategy and Leadership",
      "Non-Tech Communication",
      "Presenting Like a Pro",
    ],
    additionals: [
      "Strategy and Leadership",
      "Non-Tech Communication",
      "Presenting Like a Pro",
    ],
    tag: "top",
  },
  {
    id: 26,
    type: "Software Engineering",
    title: "CTO Leadership Course",
    decription: `This course will help you understand more about the 
    CTO role and the leadership skills you need to deliver an impact in 
    senior tech roles and become more strategic partners
    `,
    modules: [
      "Technology Strategy",
      "Understanding Technology Trends",
      "Mastering Innovation: Tools, Techniques, and Execution",
      "Building a Unicorn: Lessons from Top Silicon Valley Companies",
      "Future of Technology",
      "Leading From the Top Technology Policy, Privacy, and Security",
      "Managing and Implementing Complex Projects",
      "Product Management and Strategy",
      "Technology, Innovation, and Strategy",
    ],
    additionals: ["Technology Strategy"],
  },
  {
    id: 26,
    type: "Cybersecurity",
    title: "Cybersecurity Fundamentals",
    decription: `The Program is designed to help professionals and leaders 
    understand the application of technologies, processes and controls 
    designed to protect networks, systems, programs, devices 
    and data from cyber-attacks, damage or unauthorised access.
    `,
    modules: [
      "What Is Cybersecurity",
      "Maintain Secure Infrastructure",
      "Think Like A Hacker",
      "Security Defences",
      "Applying Cybersecurity",
      "Defending Computer Systems And Security Principles",
      "System Security: Securing Networks",
      "Monitoring And Logging For Detection Of Malicious Activity",
      "Cryptography Basics (applied Cryptography)",
      "Assessing Threats",
      "Finding Security Vulnerabilities ",
      "Fixing Security Vulnerabilities",
      "Preparing For Inevitable Attacks",
      "Introduction To Governance, Risk, And Compliance",
      "Agile Execution",
      "Audit Management",
    ],
    additionals: ["Agile Execution", "Working in Team"],
    tag: "top",
  },
  {
    id: 27,
    type: "Cybersecurity",
    title: "Enterprise Security",
    decription: `The program is designed to help Enterprises build a 
    Cybersecurity team that builds protection around company data 
    transferred across networks, devices and its end users.
    `,
    modules: [
      "Network Security Architecture",
      "Building An Enterprise Network",
      "Continuous Monitoring With A Siem",
      "Zero Trust",
      "System Hardening",
      "Policies And Compliance",
      "Cloud Management",
      "Designing Security Architecture",
      "Threat Hunting",
      "Container Vulnerabilities",
      "Api Vulnerabilities",
      "Data Governance",
      "Data Confidentiality",
      "Data Integrity",
      "Data Availability",
    ],
    additionals: ["Agile Execution", "Working in Team"],
  },
];
